import * as Immutable from 'seamless-immutable';
import { Action } from 'redux';
import { isType } from 'typescript-fsa/lib';
import {
  startLoading,
  stopLoading,
  featuredClusterEditChangeGender,
  featuredClusterEditChangeCountryId,
} from './featured-cluster-edit.actions';
import { ImmutableObject } from 'seamless-immutable';
import { AppState } from '../reducers';

interface FeatureClusterEdit {
  loading: boolean;
  gender: string;
  appId: number;
}

export type FeaturedClusterEditState = FeatureClusterEdit &
  ImmutableObject<FeatureClusterEdit>;

const initialState = Immutable.from<FeatureClusterEdit>({
  loading: true,
  gender: 'female',
  appId: 139,
});

export default function reduce(
  state: FeaturedClusterEditState = initialState,
  action: Action
) {
  if (isType(action, startLoading)) {
    return state.merge(
      {
        loading: true,
      },
      { deep: true }
    );
  }

  if (isType(action, stopLoading)) {
    return state.merge(
      {
        loading: false,
      },
      { deep: true }
    );
  }

  if (isType(action, featuredClusterEditChangeGender)) {
    const { payload } = action;
    return state.merge(
      {
        gender: payload,
      },
      { deep: true }
    );
  }

  if (isType(action, featuredClusterEditChangeCountryId)) {
    const { payload } = action;
    return state.merge({ appId: payload }, { deep: true });
  }

  return state;
}

export function getFeaturedClusterEditGender(state: AppState): string {
  const { featuredClusterEdit } = state;

  return featuredClusterEdit && featuredClusterEdit.gender
    ? featuredClusterEdit.gender
    : 'female';
}

export function getFeaturedClusterEditAppId(state: AppState): number {
  const { featuredClusterEdit } = state;

  return featuredClusterEdit && featuredClusterEdit.appId
    ? featuredClusterEdit.appId
    : 139;
}

export function getLoading(state: AppState) {
  const { featuredClusterEdit } = state;

  return featuredClusterEdit.loading || false;
}



// WEBPACK FOOTER //
// ./src/store/FeaturedClusterEdit/featured-cluster-edit.reducer.ts